import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { UserAgentProvider, withUserAgent } from 'react-ua';
import { BrowserRouter as Router } from 'react-router-dom';
import { TimerContextProvider } from './context/timer-context';
import { CookiesProvider } from 'react-cookie';
import store from './app/store';
import { Provider } from 'react-redux';
import Favicon from "react-favicon";
import { getCdnPath } from './utils/helpers';

const CompWithHoc = withUserAgent(({ ua }) => (
  <TimerContextProvider>
    <CookiesProvider>
      <App ua={ua} />
    </CookiesProvider>
  </TimerContextProvider>
));

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <UserAgentProvider>
        {process.env.REACT_APP_FAVICON_URL && <Favicon url={getCdnPath(process.env.REACT_APP_FAVICON_URL)}/>}
        <CompWithHoc />
      </UserAgentProvider>
    </Router>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
